import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { forwardRef } from "react";
export const VideoSeekbarPreview = /*#__PURE__*/ forwardRef((param, forwardedRef)=>{
    let { children, className } = param;
    return /*#__PURE__*/ _jsx("div", {
        className: classNames("pointer-events-none absolute bottom-full z-[4] hidden -translate-x-1/2 -translate-y-10 overflow-hidden rounded-4 bg-black shadow-popover ring-2 ring-white/80", "before:absolute before:bottom-2 before:left-1/2 before:flex before:h-6 before:-translate-x-1/2 before:items-center before:rounded-4 before:bg-black/60 before:px-2 before:text-center before:text-12 before:font-medium before:text-white before:backdrop-blur before:content-[attr(data-timestamp)] before:font-feature-tnum", className),
        ref: forwardedRef,
        children: children
    });
});
VideoSeekbarPreview.displayName = "VideoSeekbarPreview";
